
export const twoFAConfig = {
    "OTPHelpText": "Didn't receive the OTP yet?",
    "ResendText": "Resend OTP",
    "MobileCountryCode": "+91",
    "TimerDuration": "5",
    "TimerDecreaseBy": "1"
};